// extracted by mini-css-extract-plugin
export var button = "button-module--button--mtcvK";
export var outlined = "button-module--outlined--UFwl2";
export var primary = "button-module--primary--BaDno";
export var secondary = "button-module--secondary--UGjw-";